/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import GenericAutoComplete from "./MyAutoComplete";
import {
  fetchArticles,
  setSelectedArticle,
  clearSelectedArticle,
} from "../../store/articleSlice";

const ArticleAutocomplete = ({ required, reset, searchBy}) => {
  const dispatch = useDispatch();
  const { articleData, loading, selectedArticle } = useSelector((state) => state.article);

  // Réinitialiser la sélection lorsque `reset` passe à true
  useEffect(() => {
    if (reset) {
      dispatch(clearSelectedArticle()); // Réinitialisation quel que soit le type de recherche
    }
  }, [reset, dispatch]);
  useEffect(() => {
    return ()=> {
      dispatch(clearSelectedArticle()); // Réinitialisation quel que soit le type de recherche
    }
  }, []);

  const queryCache = React.useRef({});

  // Fonction pour effectuer la recherche dynamique basée sur `searchBy`
  const filterArticles = (searchValue) => {
    if (!searchValue.trim() || queryCache.current[searchValue]) return;

    // Vérification du type de recherche et dispatch de l'action correspondante
    if (searchBy === "name") {
      dispatch(fetchArticles({ name: searchValue }));
    } else if (searchBy === "code") {
      dispatch(fetchArticles({ code: searchValue }));
    }

    queryCache.current[searchValue] = true; // Cache la recherche pour éviter les requêtes redondantes
  };

  const handleSelect = (selectedArticle) => {
    dispatch(setSelectedArticle(selectedArticle)); // Gère l'article sélectionné
  };

  // Déterminer l'étiquette affichée (nom ou code)
  const getOptionLabel = (option) => {
    if (searchBy === "name") {
      return option.name || "";
    } else if (searchBy === "code") {
      return option.code || "";
    }
    return "";
  };

  return (
    <GenericAutoComplete
      label={searchBy === "name" ? "Nom Article" : "Code Article"}
      onSelect={handleSelect}
      fetchData={filterArticles}
      options={articleData}
      loading={loading}
      getOptionLabel={getOptionLabel}
      debounceTime={800}
      required={required}
      defaultValue={reset ? null : selectedArticle} // Réinitialisation via reset
    />
  );
};

export default ArticleAutocomplete;
